<template>
  <div class="bg">
    <b-col
      :style="{ backgroundImage: `url(${backgroundUrl})` }"
      class="bglocation d-flex w-100 align-items-end"
    >
      <div class="w-100">
        <Kathong
          :src="this.kathongs[this.da0].kathong"
          :wish="this.kathongs[this.da0].prayer"
          class="mt-1"
          size="small"
          speed="fast"
          id="1"
        />
        <Kathong
          :src="this.kathongs[this.da1].kathong"
          :wish="this.kathongs[this.da1].prayer"
          class="mt-1"
          size="small"
          speed="fastest"
          id="2"
        />
        <Kathong
          :src="this.kathongs[this.da2].kathong"
          :wish="this.kathongs[this.da2].prayer"
          class="mt-1"
          size="medium"
          speed="faster"
          id="3"
        />
        <Kathong
          :src="this.$store.state.form.srcimg"
          :wish="formData.wish"
          :name="formData.name"
          class="mt-1"
          style="z-index: 100"
          size="big"
          speed="almost_fast"
          id="4"
        />
        <button class="base-btn" @click="shareToFacebook">
          แชร์ให้เพื่อนเลย!!
        </button>
      </div>
    </b-col>
    <div class="pb-5 kathong-container"></div>
  </div>
</template>

<script>
import Kathong from "../components/kathong.vue";
import axios from "axios";

export default {
  data() {
    return {
      backgroundUrl: "",
      src: this.$store.state.form.srcimg,
      srcimg: "",
      kathongs: [],
      da0: 0,
      da1: 1,
      da2: 2,
    };
  },
  components: {
    Kathong,
  },
  computed: {
    formData() {
      return this.$store.getters.getForm;
    },
  },
  methods: {
    subMit() {
      this.$router.push("/result");
    },
    shareToFacebook() {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent("https://loykrathong.houseofdev.tech"),
        "facebook-share-dialog",
        "width=626,height=436"
      );
      return false;
    },
    async getKathong() {
      await axios
        .get("https://vulcan.houseofdev.tech/loykathong/api/getdata")
        .then((res) => {
          if (res.status == 200) {
            console.log("result-->", res.data.data);
            this.kathongs = res.data.data;
            setInterval(() => {
              if (this.da0 <= this.kathongs.length) {
                this.da0 += 1;
              } else {
                this.da0 = 0;
              }
            }, 10200);
            setInterval(() => {
              if (this.da1 <= this.kathongs.length) {
                this.da1 += 1;
              } else {
                this.da1 = 1;
              }
            }, 5200);
            setInterval(() => {
              if (this.da2 > 0) {
                this.da2 -= 1;
              } else {
                this.da2 = this.kathongs.length;
              }
            }, 7200);
          } else {
            return;
          }
        })
        .catch((err) => alert(err));
    },
  },
  mounted() {
    this.getKathong();
    this.da2 = this.kathongs.length;
    this.srcimg = this.$store.state.form.srcimg;
    if (this.$store.state.form.location === "north") {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg4.gif";
    } else if (this.$store.state.form.location === "south") {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg1.gif";
    } else if (this.$store.state.form.location === "central") {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg2.gif";
    } else if (this.$store.state.form.location === "northeast") {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg3.gif";
    }
  },
};
</script>

<style scoped>
.bg {
  position: relative;
  /* background-image: url("../assets/BG.png");
  background-repeat: no-repeat;
  height: 100vh; */
  /* background-image: linear-gradient(#48087A, #1a96A8); */
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 500px; */
  height: 100vh;
  background-size: cover;
}
.bglocation {
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
.giffile {
  /* width: 500px; */
  /* float: left; */
}

.wish {
  /* display: none; */
  position: absolute;
  top: 20px;
  left: 60%;
  /* word-break: break-all; */
  width: 120px;
  text-align: left;
}

.name {
  /* display: none; */
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  word-break: break-all;
  width: 200px;
  text-align: center;
}

/* .kathong-container {
  position: relative;
  height: 90px;
} */

.img-container {
  width: 150px;
  margin: 0 auto;
}

.img-container img {
  width: 100%;
}

/* #FAF8C9 */
/* #C5FAF1 */

.kathong {
  bottom: 0;
  position: absolute;
  -webkit-animation: linear infinite;
  -webkit-animation-name: run;
  -webkit-animation-duration: 5s;
  padding: 20px 0;
  z-index: 100;
}
@-webkit-keyframes run {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}
</style>
